module.exports = __webpack_public_path__ + "media/images/page/gift-flow01-09b5d60b25d8b05484be69178e2fb60d.jpg";